import {
	Typography,
	Grid,
	Card,
	CardMedia,
	CardContent,
	CardActions,
	Button,
} from '@material-ui/core';

import useStyles from './styles';

const Specialities = () => {
	const classes = useStyles();

	return (
		<>
			<Grid item xs={12} sm={6}>
				<Card elevation={7} className={classes.card}>
					<CardMedia
						className={classes.cardMedia}
						image="https://www.sweetysalado.com/wp-content/uploads/2014/09/DSC_0061NN.jpg"
					/>
					<CardContent>
						<Typography
							gutterBottom
							variant="h4"
							className={classes.cardTitlePrice}
						>
							Pan de banano con choco chips
						</Typography>
						<Typography align="justify" gutterBottom variant="subtitle1">
							Si el pan de banano sencillo es delicioso, no se imaginan el sabor
							de esta variación.
						</Typography>
						<CardActions className={classes.priceButtonContainer}>
							<Typography variant="h6">Precio: ₡4000</Typography>
							<a
								style={{ textDecoration: 'none' }}
								href="https://wa.link/glbj57"
							>
								<Button
									className={classes.cardButton}
									variant="contained"
									color="primary"
								>
									Hacer Pedido
								</Button>
							</a>
						</CardActions>
					</CardContent>
				</Card>
			</Grid>
			<Grid item xs={12} sm={6}>
				<Card elevation={7} className={classes.card}>
					<CardMedia
						className={classes.cardMedia}
						image="https://www.haceloconhuevos.com/wp-content/uploads/2019/08/QUEQUE-DE-BANANO-CON-NUECES-848x477.jpg"
					/>
					<CardContent>
						<Typography
							gutterBottom
							variant="h4"
							className={classes.cardTitlePrice}
						>
							Pan de ayote con arandanos
						</Typography>
						<Typography align="justify" gutterBottom variant="subtitle1">
							La combinación exótica pero sobretodo sabrosa que junto el café de
							la tarde es incomparable.
						</Typography>
						<CardActions className={classes.priceButtonContainer}>
							<Typography variant="h6">Precio: ₡4000</Typography>
							<a
								style={{ textDecoration: 'none' }}
								href="https://wa.link/glbj57"
							>
								<Button
									className={classes.cardButton}
									variant="contained"
									color="primary"
								>
									Hacer Pedido
								</Button>
							</a>
						</CardActions>
					</CardContent>
				</Card>
			</Grid>
			<Grid item xs={12} sm={6}>
				<Card elevation={7} className={classes.card}>
					<CardMedia
						className={classes.cardMedia}
						image="https://www.cocinadominicana.com/wp-content/uploads/2015/12/tapioca-recipe-pudding-DSC5267-500x500.jpg"
					/>
					<CardContent>
						<Typography
							gutterBottom
							variant="h4"
							className={classes.cardTitlePrice}
						>
							Budín de yuca
						</Typography>
						<Typography align="justify" gutterBottom variant="subtitle1">
							No es una repostería tan famosa, pero sin duda una de las más
							sabrosas, si nunca has probado, aprovecha la oportunidad.
						</Typography>
						<CardActions className={classes.priceButtonContainer}>
							<Typography variant="h6">Precio: ₡3500</Typography>
							<a
								style={{ textDecoration: 'none' }}
								href="https://wa.link/glbj57"
							>
								<Button
									className={classes.cardButton}
									variant="contained"
									color="primary"
								>
									Hacer Pedido
								</Button>
							</a>
						</CardActions>
					</CardContent>
				</Card>
			</Grid>
			<Grid item xs={12} sm={6}>
				<Card elevation={7} className={classes.card}>
					<CardMedia
						className={classes.cardMedia}
						image="http://universal.co.cr/wp-content/uploads/2018/11/navidad-400x266.png"
					/>
					<CardContent>
						<Typography
							gutterBottom
							variant="h4"
							className={classes.cardTitlePrice}
						>
							Queque navideño
						</Typography>
						<Typography align="justify" gutterBottom variant="subtitle1">
							A pesar de que normalmente ser consuma solo en Diciembre, en
							Marv's Bakery lo puedes encontrar en cualquier fecha del año.
						</Typography>
						<CardActions className={classes.priceButtonContainer}>
							<Typography variant="h6">Precio: ₡5000</Typography>
							<a
								style={{ textDecoration: 'none' }}
								href="https://wa.link/glbj57"
							>
								<Button
									className={classes.cardButton}
									variant="contained"
									color="primary"
								>
									Hacer Pedido
								</Button>
							</a>
						</CardActions>
					</CardContent>
				</Card>
			</Grid>
		</>
	);
};

export default Specialities;
